import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RefundConfigComponent } from 'src/app/popups/refund-config/refund-config.component';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ActiveInactiveFor, InteractionType, KeyValues5, LocalService, OtpType, PageKey, Status, TriggeredEvent, Wrapper10Initialization } from '../../../service/local.service';
import { SellerManagementService } from '../../../service/seller-management.service';
import { AssociatedAccountsComponent } from '../../popups/associated-accounts/associated-accounts.component';
import { KeyValueId } from 'src/app/supporting/receiptPrint';

@Component({
  selector: 'app-sellers-admin',
  templateUrl: './sellers-admin.component.html',
  styleUrls: ['./sellers-admin.component.scss']
})
export class SellersAdminComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["table", "seller", "associated_accts", "refund"]; ctryCode: string = ''; userId = ''; interactionType: InteractionType = InteractionType.None; activeInactiveFor = ActiveInactiveFor
  source: Wrapper10Initialization; maxBodyHeight = 0; isArchive: boolean = false; isBlockedOrInactive: boolean = false; selectedId: string = ''; isOpenConfirmationBox = false; isShowOtpPopup: boolean = false; OtpType = OtpType; selectedBusinessId = ''; selectedOtpType: OtpType = OtpType.None; confirmationMessage = '';

  isActionPopupOpen: boolean = false; actionTitle: string = ''; moreActionItems: KeyValues5[] = [];

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private sellerManagementService: SellerManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private modalService: NgbModal, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.configurationManagementService.ensurePageActions(PageKey.SellersAdmin);
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.userId = routeParams.userId;
      this.ctryCode = routeParams.ctryCode;
      this.onLoad();
    });
  }

  onChangeAsCountry() {
    if (this.localService && this.localService.selected && this.localService.selected.countryCode) {
      const ctryCode = this.localService.selected.countryCode == this.localService.asCtryCode ? this.localService.asCtryCode : (this.localService.selected.countryCode + '-' + this.localService.asCtryCode);

      this.router.navigate([['/sellers_admin', ctryCode, this.localService.selected.user, InteractionType.Bill_PnixSoft].join('/')]);
    }
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(10);
    this.cdr.detectChanges();
  }

  isLoading = false;
  onLoad() {
    if (!this.isLoading) {
      this.isLoading = true;
      if (!this.source) {
        this.sellerManagementService.getBusinessInitialization().subscribe(result => {
          this.source = result;
          this.isLoading = false;
        });
      } else {
        this.sellerManagementService.getBusinessesAdmin(this.source.content.paging, this.isArchive, this.isBlockedOrInactive).subscribe(result => {
          this.source.content = result;
          this.isLoading = false;
        });
      }
    }
  }

  onActiveInactiveStatus(strId: string, activeInactiveFor: ActiveInactiveFor) {
    this.sellerManagementService.activeInactiveStatus(strId, activeInactiveFor).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success || result.status == Status.SuccessWithMoreAction) {
        let updatedItem = this.source.content.items.find(x => x.key == strId);

        switch (activeInactiveFor) {
          case ActiveInactiveFor.BlockBusiness: {
            updatedItem.v1 = updatedItem.v1 == '0' ? '1' : '0';

            if (result.status == Status.SuccessWithMoreAction) {
              this.onClick(1, strId);
            }
          } break;
          case ActiveInactiveFor.ArchiveBusiness: {
            updatedItem.v5 = result.id;
          } break;
          case ActiveInactiveFor.Business: {
            updatedItem.v6 = updatedItem.v6 == '0' ? '1' : '0';
          } break;
        }
      }
    });
  }

  onClick(index, id) {
    switch (index) {
      case 0: {
        const item = this.source.content.items.find(x => x.key == id);
        this.selectedId = id;
        this.actionTitle = this.source.content.items.find(x => x.key == id).v3;
        this.moreActionItems = [
          {
            key: '1',
            v1: this.localService.languageContent.seller['billings'],
            v2: 'receipt',
            v3: ['/billings', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            key: '2',
            v1: this.localService.languageContent.seller['plan_purchase'],
            v2: 'view_timeline',
            v3: ['/plan-purchase', this.ctryCode, this.localService.selected.user, 4, id, 2].join('/')
          } as KeyValues5,
          {
            key: '3',
            v1: this.localService.languageContent.seller['sms_report'],
            v2: 'sms',
            v3: ['/sms-report', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            key: '4',
            v1: this.localService.languageContent.seller['customer_relationship'],
            v2: 'handshake',
            v3: ['/relationships', this.localService.basicParamsString, id].join('/')
          } as KeyValues5,
          {
            key: '5',
            v1: 'Receipt Templates',
            v2: 'print',
            v3: ['/receipt-templates', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            key: '6',
            v1: this.localService.languageContent.seller['custom_print_labels'],
            v2: 'new_label',
            v3: ['/custom-print-labels', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            key: '7',
            v1: this.localService.languageContent.seller['business_details'],
            v2: 'read_more',
            v3: ['/seller', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            key: '8',
            v1: this.localService.languageContent.seller['add_manage_products'],
            v2: 'shopping_cart',
            v3: ['/products', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            key: '9',
            v1: this.localService.languageContent.seller['biz_receipt'],
            v2: 'receipt',
            v3: ['/biz-receipt-custom' + this.localService.basicParamsString, 0, 0, 2, id].join('/')
          } as KeyValues5,
          {
            key: '10',
            v1: this.localService.languageContent.seller['quick_labels'],
            v2: 'label',
            v3: ['/product-categories', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            isSelected: true,
            key: '11',
            v1: this.localService.languageContent.associated_accts['header_user'],
            v2: 'private_connectivity',
            v3: id
          } as KeyValues5,
          {
            isSelected: true,
            key: '12',
            v1: this.localService.languageContent.refund['title'],
            v2: 'money_off',
            v3: id
          } as KeyValues5,
          {
            isSelected: true,
            key: '13',
            v1: item.v1 == '0' ? 'Block Account' : 'Unblock Account',
            v2: 'block',
            v3: id
          } as KeyValues5,
          {
            isSelected: true,
            key: '14',
            v1: item.v6 == '1' ? 'Make account inactive' : 'Revert account to active',
            v2: item.v6 == '1' ? 'cancel' : 'undo',
            v3: id
          } as KeyValues5,
          {
            key: '15',
            v1: this.localService.languageContent.seller['sales_report'],
            v2: 'receipt_long',
            v3: ['/sales-report', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            isSelected: true,
            key: '16',
            v1: 'Clean Data',
            v2: 'delete',
            v3: id,
            v4: 'color: red !important;'
          } as KeyValues5,
          {
            key: '17',
            v1: 'Base amount conversion with tax',
            v2: 'sync_alt',
            v3: ['/base-amount-conversion', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            isSelected: true,
            key: '18',
            v1: 'Make payment for Accepted bills',
            v2: 'paid',
            v3: id,
          } as KeyValues5,
          {
            key: '19',
            v1: 'Manage Devices',
            v2: 'important_devices',
            v3: ['/manage-devices', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
          {
            key: '20',
            v1: 'QR Label Generator',
            v2: 'qr_code_scanner',
            v3: ['/qr-label-generator', this.ctryCode, this.localService.selected.user, 4, id].join('/')
          } as KeyValues5,
        ];
        this.isActionPopupOpen = true;
      } break;
      case 1: {
        const modalRef = this.modalService.open(AssociatedAccountsComponent);
        modalRef.componentInstance.userOrBusinessId = id;
        modalRef.componentInstance.isUser = false;
        modalRef.componentInstance.countryCode = this.source.locations.selected.key;
      } break;
      case 2: {
        const modalRef = this.modalService.open(RefundConfigComponent);
        modalRef.componentInstance.userOrBusinessId = id;
        modalRef.componentInstance.interactionType = InteractionType.Business;
        modalRef.componentInstance.countryCode = this.source.locations.selected.key;
      } break;
      case 3: {
        this.router.navigate(['/biz-receipt-custom' + this.localService.basicParamsString, 0, 0, 2, id]);
      } break;
      case 4: {
        this.router.navigate(['/relationships' + this.localService.basicParamsString, id]);
      } break;
    }
  }

  onMoreActionClicked(keyId: KeyValueId) {
    switch (keyId.key) {
      case '11': {
        this.onClick(1, keyId.value);
      } break;
      case '12': {
        this.onClick(2, keyId.value);
      } break;
      case '13': {
        this.onActiveInactiveStatus(keyId.value, this.activeInactiveFor.BlockBusiness);
      } break;
      case '14': {
        this.onActiveInactiveStatus(keyId.value, this.activeInactiveFor.Business);
      } break;
      case '16': {
        this.confirmationMessage = '';
        this.selectedOtpType = OtpType.CleanBusinessData;
        this.selectedBusinessId = keyId.value;
        this.isOpenConfirmationBox = true;
      } break;
      case '18': {
        this.confirmationMessage = this.localService.languageContent.seller['confirm_paid'];
        this.selectedOtpType = OtpType.MarkAsPaidForAcceptedToken;
        this.selectedBusinessId = keyId.value;
        this.isOpenConfirmationBox = true;
      } break;
    }
  }

  onDelete(result: any) {
    this.isOpenConfirmationBox = false;
    if (result && result.event == TriggeredEvent.Ok) {
      this.isShowOtpPopup = true;
    }
  }
  onVerifiedOtp(e: any) {
    this.isShowOtpPopup = false;
  }

  onCountryUpdated(e) {
    this.source.locations.selected.key = e;
  }
}
